import { render, staticRenderFns } from "./MyReservations.vue?vue&type=template&id=456fd46c&"
import script from "./MyReservations.vue?vue&type=script&lang=js&"
export * from "./MyReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports